import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SavedSentence } from '../../models/Sentence';
import { FALLBACK_AVATAR } from '../../utils/enums';
import { PlayerPublic } from '../../models/Player';

interface UserState {
    user: UserData,
    statsUserData: UserData,
    stats: UserStats[],
    players: PlayersList[],
}

interface UserData {
    name: string,
    id: string,
    discordId: string,
    telegramId: string,
    soundsEnabled: boolean,
    directNotificationsEnabled: boolean,
    confirmActionEnabled: boolean,
    picture: string,
    dixitAvatar: string,
}

interface PlayersList {
    name: string,
    id: string,
    picture: string,
}

interface DixitGame {
    roundsPlayed: number;
    turnsPlayed: number;
    cardsPlayed: number;
    deckSize: number;
    handSize: number;
    maxRounds: number;
    maxTurns: number;
    maxScore: number;
    maxCards: number;
    gameStartedDateTime: Date;
    discordChannelId: string;
    asyncPlay: boolean;
}

interface UserStats {
    game: DixitGame;
    sentencePlayerGame: SavedSentence[];
    score: number;
    guessCount: number;
    matchCount: number;
    waitingForCount: number;
    onlyGuesserCount: number;
    maxScoreTurnCount: number;
    guessScore: number;
    storytellerVoteCount: number;
    successfulStorytellCount: number;
    failedStorytellerAllCount: number;
    failedStorytellerNoOneCount: number;
    storytellerScore: number;
    failedStorytellerScore: number;
    isWinner: boolean;
    place: number;
}

const userInitialState: UserData = {
    name: '',
    id: '',
    discordId: '',
    telegramId: '',
    soundsEnabled: false,
    picture: FALLBACK_AVATAR,
    dixitAvatar: '',
    confirmActionEnabled: false,
    directNotificationsEnabled: false,
}

const initialState: UserState = {
    user: userInitialState,
    statsUserData: userInitialState,
    stats: [],
    players: [],
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        // for saving settings
        sendUser: ((state, action: PayloadAction<{
            playerId: string
        }>) => {
            return;
        }),

        receiveUser: ((state, action: PayloadAction<any>) => {
            state.user.name = action.payload.user.name;
            state.user = Object.assign(state.user, { ...action.payload.user });
        }),

        receiveStats: ((state, action: PayloadAction<any>) => {
            state.stats = [...action.payload.stats];
            state.statsUserData = Object.assign(state.user, { ...action.payload.statsUserData });
        }),

        receivePlayers: ((state, action: PayloadAction<any>) => {
            state.players = [...action.payload.players];
        }),

        soundEnabled: ((state, action: PayloadAction<boolean>) => {
            state.user.soundsEnabled = action.payload;
        }),

        confirmActionEnabled: ((state, action: PayloadAction<boolean>) => {
            state.user.confirmActionEnabled = action.payload;
        }),

        directNotificationsChange: ((state, action: PayloadAction<boolean>) => {
            state.user.directNotificationsEnabled = action.payload;
        }),
    }
});

export const userActions = userSlice.actions;
export default userSlice.reducer;